import { render, staticRenderFns } from "./LedgerDownloadReport.vue?vue&type=template&id=35fc06fa&scoped=true&"
import script from "./LedgerDownloadReport.vue?vue&type=script&lang=js&"
export * from "./LedgerDownloadReport.vue?vue&type=script&lang=js&"
import style0 from "./LedgerDownloadReport.vue?vue&type=style&index=0&id=35fc06fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35fc06fa",
  null
  
)

export default component.exports